import { StatusBanner } from '@/ui/composites';
import type { ReactElement } from 'react';

type ExecutionRunsRouteNoticeBannerProps = {
  notice: string | null;
  setNotice: (notice: string | null) => void;
};

export const RouteNoticeBanner = ({
  notice,
  setNotice,
}: ExecutionRunsRouteNoticeBannerProps): ReactElement | null =>
  notice ? (
    <StatusBanner
      tone="blue"
      message={notice}
      onClose={() => {
        setNotice(null);
      }}
    />
  ) : null;
